import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

export default function PDFViewer({ pdfUrl }) {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight - 150,
  });
  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight - 200,
      });
    };
    window.addEventListener('resize', handleResize);
  }, []);
  return (
    <div onContextMenu={e => e.preventDefault()}>
      <Box
        style={{
          border: '2px solid',
          '@media print': {
            embed: {
              display: 'none !important',
            },
          },
        }}>
        <embed
          src={`${pdfUrl}#toolbar=0&navpanes=0`}
          onContextMenu="return false;"
          style={{
            width: '100%',
            height: `${dimensions.height}px`,
            border: 'none',
          }}
        />
      </Box>
    </div>
  );
}
